// customCursorHint — 自分のカーソルエディタへの「気づき」ヒント (custom-cursor-ux
// 2026-09-19 フォローアップ, 作者 staging フィードバック §A-1「入口が分かりづらい」)。
//
// 背景: カーソルエディタへの主導線は参加者リストの自分の行 (未作成なら点線「＋」
// プレースホルダ)。それでも初見では気づきにくいので、**一度もエディタを開いたことが
// ない端末**では自分の行のプレースホルダを数回ゆっくり pulse させ「ここで作る」を
// 示す。エディタを一度でも開いたら (どの入口からでも) 以後は出さない。
//
// pure な storage helper だけをここに置き (`cursorEditorPopup.ts` と同じ流儀)、
// React 側の pulse アニメーション自体は呼び出し側 (MemberPanel) の CSS が担う。

/** Minimal Storage shape (`layerPopup.ts` の `StorageLike` と同流儀、循環 import を避けて複製)。 */
export interface StorageLike {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

/** localStorage キー。値は仕様書 (custom-cursor-2026-09-19.md フォローアップ) 指定のもの。 */
export const CURSOR_EDITOR_HINT_SEEN_KEY = 'oekaki.customCursor.hintSeen.v1';

/**
 * 「一度でもカーソルエディタを開いたことがあるか」を読む。不在 / 不正値 / storage 不可は
 * すべて `false` (= まだ見せていない扱い、フェイルセーフ) に倒す。
 */
export const readCursorEditorHintSeen = (storage: StorageLike): boolean => {
  try {
    return storage.getItem(CURSOR_EDITOR_HINT_SEEN_KEY) === '1';
  } catch {
    return false;
  }
};

/**
 * 「開いた」を記録する。エディタが実際に開かれた瞬間 (= どの入口からでも) に呼ぶ。
 * storage 不可 / quota 超過は silently drop (= 動作継続を優先、次回また pulse するだけ)。
 */
export const markCursorEditorHintSeen = (storage: StorageLike): void => {
  try {
    storage.setItem(CURSOR_EDITOR_HINT_SEEN_KEY, '1');
  } catch {
    // 永続化できないだけで動作は継続させる.
  }
};
